import { computed, type Ref } from 'vue'

import {
  type WebfleetStatus,
  STATUS_WEBFLEET_LOOKUP_LABEL,
} from '@/constants/persoplan'
import scssVariables from '@/assets/scss/scssVariables'

export type { WebfleetStatus } from '@/constants/persoplan'

interface Options {
  status: Ref<WebfleetStatus | undefined | null>
}

const colors = {
  created: scssVariables.color['status-webfleet-created'],
  updated: scssVariables.color['status-webfleet-updated'],
  workInProgress: scssVariables.color['status-webfleet-workInProgress'],
  aborted: scssVariables.color['status-webfleet-aborted'],
  deleted: scssVariables.color['status-webfleet-deleted'],
} as const satisfies Partial<Record<WebfleetStatus, string>>

export function useWebfleetStatus(options: Options) {
  const classes = computed(() => {
    if (!options.status.value) return

    return {
      [`is-statusWebfleet-${options.status.value}`]: true,
    }
  })

  const color = computed(() => {
    if (!options.status.value) return

    return colors[options.status.value]
  })

  const label = computed(() => {
    if (!options.status.value) return
    return STATUS_WEBFLEET_LOOKUP_LABEL[options.status.value]
  })

  return {
    classes,
    color,
    label,
  }
}
